import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { bp, hoverSpoofer } from 'Styles/helpers';
import screen from 'superior-mq';
import Section from '../../section';
import Container from '../../container';
import ContentBlock from '../../content-block';
import Grid from '../../grid';
import Button from '../../button';
import ProgramCard from '../../program-card';
import TextWave from '../../text-wave';
import RenderMd from '../../render-md';

const GridCard = styled(Grid.Item)`

  ${screen.below(bp.tablet, `
    grid-column: span 6;
  `)};

  ${props => props.totalCards === 1 && css`
    ${screen.above(bp.tablet, `
      grid-column: 10 / span 6;
    `)}

    ${screen.below(bp.tablet, `
      grid-column: 4 / span 6;
    `)}
  `}

  ${props => props.totalCards === 2 && css`
    ${screen.above(bp.tablet, `
      &:first-of-type {
        grid-column: 7 / span 6;
      }
    `)}
  `}

  ${props => props.totalCards === 3 && css`
    ${screen.above(bp.tablet, `
      &:first-of-type {
        grid-column: 4 / span 6;
      }
    `)}
  `}
`;

const gridStyles = `
  max-width: 1120px;
  margin: 40px auto 70px;
  align-items: stretch;

  ${screen.above(bp.tablet, `
    margin: 90px auto 70px;
    grid-gap: 28px;
  `)};

  ${screen.below(bp.tablet, `
    grid-template-columns: repeat(12, 1fr);
    grid-row-gap: 40px;
  `)};

  ${hoverSpoofer(GridCard)}
`;

const ProgramSupport = ({ related, overview }) => (
  <SupportSection>
    <Container>

      <ContentBlock>
        <TextWave>
          <h2>Support This Program</h2>
        </TextWave>

        {overview
          ?
            <RenderMd source={overview} />
          :
            <React.Fragment>
              <p>
                The funds raised through this program will go directly towards the implementation
                of water filtration systems, the construction or repair of bore-hole wells, and/or
                rainwater harvesting systems.
              </p>
              <p>
                In addition, you can create a personal fundraiser page. 100% of the funds raised
                through your fundraiser will go towards the specific Waves For Water program that
                you select when creating your fundraiser.
              </p>
            </React.Fragment>
        }

      </ContentBlock>

      <Grid styles={gridStyles} cols={24}>

        {related.length > 0 && related.map(fundraiser => (
          <GridCard
            span={6}
            key={fundraiser.id}
            totalCards={related.length}
          >
            <ProgramCard
              program={fundraiser}
              parentRoute="/fundraisers"
            />
          </GridCard>
        ))}
      </Grid>

      <ProgramSupportButton href="/fundraisers">View All</ProgramSupportButton>
    </Container>
  </SupportSection>
);

export const SupportSection = styled(Section)``;

const ProgramSupportButton = styled(Button)`
  display: block;
  margin: auto;

  ${screen.below(bp.tablet, `
    width: 162px;
  `)};
`;

ProgramSupport.propTypes = {
  related: PropTypes.array,
  overview: PropTypes.string,
};

ProgramSupport.defaultProps = {
  related: [],
};

export default ProgramSupport;
